import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import ProductsSection from './components/ProductsSection';
import CPCOffers from './components/CPCOffers';
import EmailCapture from './components/EmailCapture';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import ExitIntentPopup from './components/ExitIntentPopup';
import { Toaster } from './components/ui/sonner';
import Dashboard from './pages/Dashboard';
import Blog from './pages/Blog';
import BestAffiliateProducts2025 from './pages/blog/BestAffiliateProducts2025';

function App() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-50 selection:bg-cyan-500/30">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <HowItWorks />
              <ProductsSection />
              <CPCOffers />
              <Testimonials />
              <FAQ />
              <EmailCapture />
            </>
          } />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/best-affiliate-products-2025" element={<BestAffiliateProducts2025 />} />
        </Routes>
      </main>
      <Footer />
      <ExitIntentPopup />
      <Toaster />
    </div>
  );
}

export default App;
